import { HOTSPOT_PRODUCT_LOAD_STATUS } from 'Component/ShopByLookProductPopup/ShopByLookProductPopup.config';
import ProductListQuery from 'Query/ProductList.query';
import ShopByLookQuery from 'Query/ShopByLook.query';
import CartDispatcher from 'Store/Cart/Cart.dispatcher';
import { showNotification } from 'Store/Notification/Notification.action';
import { updateHotSpots, updateSlides } from 'Store/ShopByLook/ShopByLook.action';
import { prepareQuery } from 'Util/Query';
import { fetchMutation, fetchQuery, QueryDispatcher } from 'Util/Request';
import { ONE_MONTH_IN_SECONDS } from 'Util/Request/QueryDispatcher';
import { executeGet } from 'Util/Request/Request';
import { prepareSlidesWithHotspot } from 'Util/ShopByLook';

/** @namespace AllHomePwafe/Store/ShopByLook/Dispatcher/ShopByLookDispatcher */
export class ShopByLookDispatcher extends QueryDispatcher {
    getSlideList({
        pageSize, currentPage = 1, dispatch, slide_url, slide_id
    }) {
        const query = ShopByLookQuery.getSlideList({
            pageSize, currentPage, slide_url, slide_id
        });

        return fetchQuery(query).then(
            /** @namespace AllHomePwafe/Store/ShopByLook/Dispatcher/fetchQuery/then */
            (slideData) => {
                if (slide_url || slide_id) {
                    const { kmSlides: { items: [slide = {}] } } = slideData;
                    const { related: { items: relatedSlides = [] } = {} } = slide;
                    const finalSlides = prepareSlidesWithHotspot([{ ...slide }, ...relatedSlides]);
                    dispatch(updateSlides(finalSlides));
                    finalSlides.forEach((slide) => {
                        this.getHotSpotProductData({ slide, dispatch });
                    });
                }

                return slideData;
            },
            /** @namespace AllHomePwafe/Store/ShopByLook/Dispatcher/fetchQuery/then */
            () => this.onError({
                errorMessage: __('Error fetching List!'), dispatch
            })
        );
    }

    async getHotSpotProductData({ slide, dispatch }) {
        const { hotspots, slide_id } = slide;
        const hotspotWithProducts = Array.from(hotspots);
        if (!hotspotWithProducts.length) {
            return;
        }

        // eslint-disable-next-line no-restricted-syntax
        for (const hotspot of hotspotWithProducts) {
            if (!hotspot.sku) {
                hotspot.productLoadState = HOTSPOT_PRODUCT_LOAD_STATUS.NO_SKU;
            }
            try {
                // eslint-disable-next-line no-await-in-loop
                const productData = await this.getProductData({ sku: hotspot.sku, dispatch });
                if (productData) {
                    hotspot.product = productData;
                    hotspot.productLoadState = HOTSPOT_PRODUCT_LOAD_STATUS.SUCCESS;
                } else {
                    hotspot.productLoadState = HOTSPOT_PRODUCT_LOAD_STATUS.NO_PRODUCT_FROM_SKU;
                }
            } catch (e) {
                hotspot.productLoadState = HOTSPOT_PRODUCT_LOAD_STATUS.ERROR;
            }
        }
        dispatch(updateHotSpots({ slide_id, hotspots: hotspotWithProducts }));
    }

    async getProductData({ sku }) {
        const options = {
            isSingleProduct: true,
            args: { filter: { productSKU: sku } }
        };

        const query = ProductListQuery.getQuery(options);

        const productData = await executeGet(prepareQuery(query), 'Product', ONE_MONTH_IN_SECONDS);

        if (productData && productData.products && productData.products.items) {
            return productData.products.items[0];
        }

        return null;
    }

    getSlideByUrlKey({ dispatch, slide_url }) {
        return this.getSlideList({ dispatch, pageSize: 1, slide_url });
    }

    getSlideById({ dispatch, slide_id }) {
        return this.getSlideList({ dispatch, pageSize: 1, slide_id });
    }

    addAllLookItemsToCart(dispatch, shopTheLookId) {
        const query = ShopByLookQuery.shopTheLookQuery(shopTheLookId);

        return fetchMutation(query).then(
            /** @namespace AllHomePwafe/Store/ShopByLook/Dispatcher/fetchMutation/then */
            (response) => {
                const { kmShopTheLook: { message, type } } = response;
                dispatch(showNotification(type, message));
                CartDispatcher.fetchAndUpdateCart(dispatch);
            },
            /** @namespace AllHomePwafe/Store/ShopByLook/Dispatcher/fetchMutation/then */
            () => this.onError({
                errorMessage: __('Error in adding the items to cart!'), dispatch
            })
        );
    }

    onError({ error = '', errorMessage, dispatch }) {
        dispatch(showNotification('error', errorMessage, error));
    }
}

export default new ShopByLookDispatcher();
